import { defineStore } from 'pinia'
import type { RouteRecordRaw } from 'vue-router'

import type { ContentWidth, LayoutType, ThemeType } from '../../types/app'

import defaultSetting, { type AnimationNameValueType } from '@/configs'
import { LIST_THEMES } from '@/utils/constants'
export interface LayoutSetting {
  title?: string
  logo?: string
  theme: ThemeType
  collapsed: boolean
  drawerVisible: boolean
  colorPrimary?: string
  layout?: LayoutType
  contentWidth?: ContentWidth
  fixedHeader?: boolean
  fixedSider?: boolean
  splitMenus?: boolean
  watermark?: boolean
  header?: boolean
  footer?: boolean
  menu?: boolean
  menuHeader?: boolean
  colorWeak?: boolean
  colorGray?: boolean
  multiTab?: boolean
  multiTabFixed?: boolean
  headerHeight?: number
  copyright?: string
  keepAlive?: boolean
  accordionMode?: boolean
  leftCollapsed?: boolean
  compactAlgorithm?: boolean
  animationName?: AnimationNameValueType
}
export const useAppStore = defineStore(
  'appStore',
  () => {
    const layoutSetting = reactive<LayoutSetting>(defaultSetting)
    const loading = ref(false)
    const isCollapseMenu = ref(false)
    const theme = ref('')
    const currentAppName = ref('VNP WATER')
    const menuData = ref<RouteRecordRaw[]>([])

    const setLoading = (payload: boolean) => {
      loading.value = payload
    }
    const setMenu = (payload: boolean) => {
      isCollapseMenu.value = payload
    }
    const setTheme = (t: string) => {
      const app = document.querySelector('html')

      if (app) {
        LIST_THEMES.filter((l: { class: string }) => l.class !== t).forEach(
          (l: { class: string }) => app.classList.remove(l.class)
        )
        app.classList.add(t)
        theme.value = t
      }
    }

    return {
      layoutSetting,
      loading,
      isCollapseMenu,
      theme,
      currentAppName,
      menuData,
      setLoading,
      setMenu,
      setTheme,
    }
  },
  { persist: true }
)
